import React, { Component } from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withFormik } from "formik";
import * as Yup from "yup";

import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import Grid from "@material-ui/core/Grid";
import IconButton from '@material-ui/core/IconButton';
import InputLabel from "@material-ui/core/InputLabel";
import LinearProgress from '@material-ui/core/LinearProgress';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Paper from '@material-ui/core/Paper';
import Select from '@material-ui/core/Select';
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import Toolbar from '@material-ui/core/Toolbar';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';

import ClearIcon from "@material-ui/icons/Clear";

import AdminWrapper from "../../containers/AdminWrapper";
//component
import ContentWrapper from "../../containers/ContentWrapper";
//redux actions
import * as dialogActions from "../../redux/actions/dialogactions";
//redux constant
import * as shootTypes from "../../redux/constants/ShootsActionTypes";
//services
import accountService from "../../services/accountsService";
import shootService from "../../services/shootService";
import AddLanguageDialog from "../Dialogs/AddLanguageDialog";
import AddServiceDialog from "../Dialogs/AddServiceDialog";
import AddStaffDialog from "../Dialogs/AddStaffDialog";
import ConfirmationDialog from "../Dialogs/ConfirmationDialog";
import ClientLanguageSection from "./ClientLanguageSection";
import ClientServicesSection from "./ClientServicesSection";
import ClientStaffSection from "./ClientStaffSection";





class ShootDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      validateCalled: false,
      updatingDetails: false,
    };
  }

  componentDidMount(){
    let companyRef = ReactDOM.findDOMNode(this.companyRef);
    this.setState({
      companyLabelWidth: companyRef.offsetWidth
    });
  }

  submitDetails = async () => {
    console.log('tawag');
    try {
      this.setState({updatingDetails: true})
        let { name, address, shooter, selectedDate, hasInterview, } = this.props.values;
        let created_at = this.props.match.params.date;
        let clinic = this.props.match.params.client;
        let date = new Date(selectedDate).getTime();
        date = date.toString();
        await shootService.changeShootDetails(
          { clinic, created_at },
          {
            clinic: name,
            address,
            date,
            shooter_id: shooter,
            hasInterview,
            created_at: this.props.values.created_at
          }
        );
        await this.props.getDetails();
        this.setState({updatingDetails: false })
    } catch (err) {
      console.log(err);
      this.setState({ updatingDetails: false })
    }
  };

  render() {
    const { validateCalled } = this.state;
    const {
      handleChange,
      handleBlur,
      errors,
      values,
      touched,
    } = this.props;
    const disabled = this.state.updatingDetails
    return (
      <>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Typography component="span" variant="h6" color="inherit">
            Shoot Details
          </Typography>
          <Button
            color="primary"
            onClick={this.submitDetails}
            size="small"
            disabled={disabled}
          >
            Save Shoot
            {disabled ? (
              <CircularProgress
                color="primary"
                size={12}
                style={{ marginLeft: 5 }}
              />
            ) : null}
          </Button>
        </div>
        {disabled && (
          <LinearProgress
            color="primary"
            style={{ height: 2, marginTop: 20 }}
          />
        )}
        <Paper
          style={
            disabled
              ? { padding: 24 }
              : { padding: 24, marginTop: 20 }
          }
        >
          <Typography
            component="span"
            variant="subtitle2"
            color="inherit"
            gutterBottom
          >
            Please update the details of the shoot.
          </Typography>
          <TextField
            autoComplete="off"
            id="name"
            helperText={(touched.name || validateCalled) && errors.name}
            error={(touched.name || validateCalled) && errors.name}
            value={values.name}
            onBlur={handleBlur}
            onChange={handleChange}
            label="Client name"
            margin="normal"
            style={{ width: "100%" }}
            variant="outlined"
            disabled={disabled}
          />
          <TextField
            autoComplete="off"
            value={this.state.address}
            id="address"
            helperText={(touched.address || validateCalled) && errors.address}
            error={(touched.address || validateCalled) && errors.address}
            value={values.address}
            onBlur={handleBlur}
            onChange={handleChange}
            label="Address"
            margin="normal"
            style={{ width: "100%" }}
            variant="outlined"
            disabled={disabled}
          />
          <FormControl
            variant="outlined"
            style={{ width: "100%" }}
            margin="normal"
            error={(touched.shooter || validateCalled) && errors.shooter}
          >
            <InputLabel
              ref={ref => {
                this.companyRef = ReactDOM.findDOMNode(ref);
              }}
              htmlFor="outlined-age-native-simple"
            >
              Shooter
            </InputLabel>
            <Select
              value={values.shooter}
              native
              input={
                <OutlinedInput
                id="shooter"
                  labelWidth={this.state.companyLabelWidth}
                  style={{ width: "100%" }}
                  error={
                    (touched.shooter || validateCalled) && errors.shooter
                  }
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
              }
              disabled={disabled}
            >
              <option value="" />
              {this.props.shooterList.map((shooter) => {
                const { Attributes } = shooter;
                return (
                  <option key={Attributes.email} value={shooter.Username}>{`${
                    Attributes.given_name
                  } ${Attributes.family_name} — ${Attributes.email}`}</option>
                );
              })}
            </Select>
                  <FormHelperText
                    error={
                      (touched.shooter || validateCalled) && errors.shooter
                    }
                  >
                    {(touched.shooter || validateCalled) && errors.shooter}
                  </FormHelperText>
          </FormControl>
          <TextField
                  id="selectedDate"
                  label="Shoot Schedule"
                  type="datetime-local"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true
                  }}
                  value={values.selectedDate}
                  style={{ width: "100%", margin: "16px 0 8px 0" }}
                  onChange={handleChange}
            disabled={disabled}
          />
          <FormControlLabel
            control={
              <Switch
              id="hasInterview"
              checked={values.hasInterview}
              color="primary"
              onChange={handleChange}
              disabled={values.saving}
              />
            }
            label={
              values.hasInterview ? "With interview" : "Without interview"
            }
            labelPlacement="end"
          />
        </Paper>
      </>
    );
  }
}

const WithFormikShootDetails = withFormik({
  mapPropsToValues: props => {
    console.log(props)
    let {shootDetails} = props
    return {
      name: shootDetails.name,
      address: shootDetails.address,
      company: "Freelance",
      hasInterview: shootDetails.hasInterview,
      selectedDate: shootDetails.selectedDate,
      shooter: shootDetails.shooter,
      created_at: shootDetails.created_at
    };
  },
  validationSchema: Yup.object().shape({
    name: Yup.string().required("Client name is required"),
    address: Yup.string().required("Client address is required!"),
    selectedDate: Yup.string().required("Date of the shoot is required!"),
    shooter: Yup.string().required("Please assign a shooter.")
  }),
  validateOnChange: true
})(ShootDetails);



class EditShoot extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      address: "",
      company: "Freelance",
      hasInterview: false,
      selectedDate: "",
      shooter: null,
      staffs: [],
      languages: [],
      staticLanguages: [],
      services: [],
      shooterList: [],

      addStaffDialog: false,
      addLanguageDialog: false,
      addServiceDialog: false,
      saving: false,
      fetching: true,
      failed: false,

      updatingStaffs: false,
      updatingLanguages: false,
      updatingServices: false,
      updatingDetails: false,

      categoryLabelWidth: 0,
      companyLabelWidth: 0
    };
  }

  getTimeFormat = timestamp => {
    console.log(timestamp);
    let date = new Date(parseInt(timestamp));
    return `${date.getFullYear()}-${
      date.getMonth() + 1 >= 10
        ? date.getMonth() + 1
        : "0" + (date.getMonth() + 1)
    }-${date.getDate() >= 10 ? date.getDate() : "0" + date.getDate()}T${
      date.getHours() >= 10 ? date.getHours() : "0" + date.getHours()
    }:${date.getMinutes() >= 10 ? date.getMinutes() : "0" + date.getMinutes()}`;
  };

  async componentDidMount() {
    //get shoot details
    this.getShootFullDetails();

    const data = await accountService.getAccounts();
    console.log("here",data)
    this.setState({ shooterList: data });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.confirmDialog && !this.props.confirmDialog) {
      console.log("Modal closed!");
      console.log(prevProps.confirmDialog, this.props.confirmDialog);
      //have a switch to determine what action should we take, but if we only have one action
      //there is no need to have a switch .
      if (this.props.confirmChoice) {
        switch (this.props.confirmAction) {
          case shootTypes.SHOOTS_SAVE_SHOOT:
            console.log("saving shoot");
            this.saveShoot();
            break;
          default:
            break;
        }
      }
    }
  }

  getShootFullDetails = async () => {
    try {
      this.setState({ fetching: true });
      let { client, date } = this.props.match.params;
      let created_at = date;
      let clinic = client;
      let detailsRequest = shootService.getOneShoot(
        {
          clinic,
          created_at
        },
        {
          params: {
            type: "details"
          }
        }
      );
      let serviceRequest = shootService.getShootServices({
        clinic,
        created_at
      });
      let staffRequest = shootService.getShootStaff({ clinic, created_at });
      let languageRequest = shootService.getShootLanguages({
        clinic,
        created_at
      });
      let [details, services, languages, staffs] = await Promise.all([
        detailsRequest,
        serviceRequest,
        languageRequest,
        staffRequest
      ]);
      details = details.data.shoot;
      services = services.data;
      languages = languages.data;
      staffs = staffs.data;
      console.log(details);
      this.setState({
        name: details.clinic,
        address: details.address,
        selectedDate: this.getTimeFormat(details.date),
        hasInterview: details.hasInterview,
        shooter: details.shooter_id,
        created_at: details.created_at,
        staffs,
        languages,
        staticLanguages: languages,
        services,
        fetching: false
      });
    } catch (err) {
      console.log(err);
      this.setState({
        fetching: false,
        failed: true
      });
    }
  };

  getStaff = async () => {
    try {
      this.setState({ updatingStaffs: true });
      let { client, date } = this.props.match.params;
      let created_at = date;
      let clinic = client;
      let { data } = await shootService.getShootStaff({ clinic, created_at });
      this.setState({ staffs: data });
      this.setState({ updatingStaffs: false });
    } catch (err) {
      console.log(err);
      this.setState({ updatingStaffs: false });
    }
  };

  getDetails =  () => {
      this.setState({ updatingDetails: true });
      let { client, date } = this.props.match.params;
      let created_at = date;
      let clinic = client;
      return shootService.getOneShoot(
        {
          clinic,
          created_at
        },
        {
          params: {
            type: "details"
          }
        }
      );
  };

  getLanguages = async () => {
    try {
      this.setState({ updatingLanguages: true });
      let { client, date } = this.props.match.params;
      let created_at = date;
      let clinic = client;
      let { data } = await shootService.getShootLanguages({
        clinic,
        created_at
      });
      this.setState({ staticLanguages: data, languages: data, updatingLanguages: false });
    } catch (err) {
      console.log(err);
      this.setState({ updatingLanguages: false });
    }
  };

  getServices = async () => {
    try {
      this.setState({ updatingServices: true });
      let { client, date } = this.props.match.params;
      let created_at = date;
      let clinic = client;
      let { data } = await shootService.getShootServices({
        clinic,
        created_at
      });
      this.setState({ services: data, updatingServices: false });
    } catch (err) {
      console.log(err);
      this.setState({ updatingServices: false });
    }
  };

  deletelanguage = async language => {
    try {
      this.setState({ updatingLanguages: true });
      let { client, date } = this.props.match.params;
      let created_at = date;
      let clinic = client;
      await shootService.deleteLanguageToShoot({
        clinic,
        created_at,
        language
      });
      this.getLanguages();
    } catch (err) {
      console.log(err);
      this.setState({ updatingLanguages: false });
    }
  };

  deleteStaff = async id => {
    try {
      this.setState({ updatingStaffs: true });
      let { client, date } = this.props.match.params;
      let created_at = date;
      let clinic = client;
      await shootService.deleteStaffToShoot({
        clinic,
        created_at,
        staff: id
      });
      this.getStaff();
    } catch (err) {
      console.log(err);
      this.setState({ updatingStaffs: false });
    }
  };

  deleteService = async service => {
    try {
      this.setState({ updatingServices: true });
      let { client, date } = this.props.match.params;
      let created_at = date;
      let clinic = client;
      await shootService.deleteServiceToShoot({
        clinic,
        created_at,
        service
      });
      this.getServices();
    } catch (err) {
      console.log(err);
      this.setState({ updatingServices: false });
    }
  };

 

  submitStaff = async (firstname, lastname, position, email) => {
    try {
      let { client, date } = this.props.match.params;
      let created_at = date;
      let clinic = client;
      this.setState({ updatingStaffs: true });
      await shootService.addStaffToShoot(
        { clinic, created_at },
        { firstname, lastname, position, email }
      );
      this.getStaff();
    } catch (err) {
      console.log(err);
      this.setState({ updatingStaffs: false });
    }
  };

  submitLanguage = async language => {
    try {
      let { client, date } = this.props.match.params;
      let created_at = date;
      let clinic = client;
      this.setState({ updatingLanguages: true });
      await shootService.addLanguageToShoot(
        { clinic, created_at },
        { language }
      );
      this.getLanguages();
    } catch (err) {
      console.log(err);
      this.setState({ updatingLanguages: false });
    }
  };

  submitService = async service => {
    try {
      let { client, date } = this.props.match.params;
      let created_at = date;
      let clinic = client;
      this.setState({ updatingServices: true });
      await shootService.addServiceToShoot({ clinic, created_at }, { service });
      this.getServices();
    } catch (err) {
      console.log(err);
      this.setState({ updatingServices: false });
    }
  };

  addStaff = () =>
    this.setState({ addStaffDialog: !this.state.addStaffDialog });

  addLanguage = () =>
    this.setState({ addLanguageDialog: !this.state.addLanguageDialog });

  addService = () =>
    this.setState({ addServiceDialog: !this.state.addServiceDialog });

  handleChange = name => e => {
    let state = this.state;
    state[name] = e.target.value;
    this.setState(state);
  };

  //give the components one functions so they can run it
  /*
  pass a function to the dialog component that accepts
  a value argument which is a object of the element that will
  be added to the array.
  {
    name: '',//staffs || languages || services
    value: {
      firstname: "example",
      lastname: "example",
      position: "example"
    }
  }
  */
  updateState = object => {
    let newState;
    if (object.name === "staffs") {
      let { firstname, lastname, position, email } = object.value;
      this.submitStaff(firstname, lastname, position, email);
    } else if (object.name === "services") {
      this.submitService(object.value);
    } else 
    {
      new Error(
        "The argument type is not acceptable it must be object or string"
      );
    }

    this.setState(newState, () => {
      let value;
      let objectName;
      if (object.name === "staffs") {
        value = !this.state.addStaffDialog;
        objectName = "addStaffDialog";
      } else if (object.name === "services") {
        value = !this.state.addServiceDialog;
        objectName = "addServiceDialog";
      } else if (object.name === "languages") {
        value = !this.state.addLanguageDialog;
        objectName = "addLanguageDialog";
      } else {
        new Error(`${object.name} is not an acceptable argument!`);
      }
      this.setState({ [objectName]: value });
    });
  };

  removeItem = (name, index) => {
    let state = this.state;
    state[name].splice(index, 1);
    this.setState(state);
  };

  handleToggle = (name) => {
    const currentIndex = this.state.languages.indexOf(name);
    const newChecked = [...this.state.languages];

    console.log('clear', name, currentIndex, newChecked, this.state.staticLanguages);

    if (currentIndex === -1) {
      console.log('first');
      newChecked.push(name);
    } else {
      
      newChecked.splice(currentIndex, 1);
    }
    this.setState({
      languages: newChecked
    });

    if(this.state.staticLanguages.includes(name) && currentIndex !== -1){
      this.deletelanguage(name);
    }else{
      this.submitLanguage(name);
    }

  }

  confirmSaveShoot = () => {
    this.props.dialogActions.openConfirmDialog(
      "Are you sure?",
      "You are about to save the shoot.",
      shootTypes.SHOOTS_SAVE_SHOOT,
      "Cancel",
      "Confirm"
    );
  };

  saveShoot = async () => {
    //dispatch an action so that we can save the shoot
    //in the saga that will be created.
    // console.log("save the shoot!");
    console.log('language', this.state.languages)
    try {
      this.setState({ saving: true });
      await shootService.addShoot({
        clinic: this.state.name,
        address: this.state.address,
        company: "Freelance",
        date: new Date(this.state.selectedDate).getTime(),
        language: this.state.languages,
        staff: this.state.staffs,
        service: this.state.services,
        cognitoId: this.state.shooter,
        hasInterview: this.state.hasInterview,
        created_at: this.state.created_at
      });

      this.props.history.push("/shoots");
    } catch (err) {
      this.setState({ saving: false });
      console.log(err);
    }
  };

  handleDateChange = date => {
    this.setState({ selectedDate: date });
  };

  hasInterviewChange = (e, checked) => {
    this.setState({
      hasInterview: checked
    });
  };

  render() {
    return (
      <AdminWrapper {...this.props}>
        <ContentWrapper hasHeader title="Edit Shoot" hasPadding>
          {this.state.fetching ? (
            <div style={{ textAlign: "center", padding: "50px 0" }}>
              <CircularProgress color="primary" />
            </div>
          ) : (
            <>
              {/* <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={this.props.history.goBack}
                >
                  Back
                </Button>
              </div> */}

              <Toolbar variant="dense" style={{padding: '10px 5px'}} disableGutters={true}>
                <Tooltip title="Cancel">
                  <IconButton onClick={this.props.history.goBack} aria-label="cancel" color="secondary">
                    <ClearIcon/>
                  </IconButton>
                </Tooltip>
                {/* <div style={{flexGrow: 1}} />
                <Tooltip title="Save Shoot">
                  <Button variant="fab" onClick={this.submitDetails} color="primary" mini aria-label="Add" style={{marginLeft: '5px', boxShadow: 'none'}}>
                    <SaveIcon />
                  </Button>
                </Tooltip> */}
              </Toolbar>

              <div style={{ display: "flex", justifyContent: "center" }}>
                <Grid item xd={12} sm={10} md={6} style={{ marginTop: 50 }}>
                  {/* SHOOT DETAILS */}
                  <WithFormikShootDetails 
                    shootDetails={{
                      address: this.state.address,
                      name: this.state.name,
                      created_at: this.state.created_at,
                      selectedDate: this.state.selectedDate,
                      hasInterview: this.state.hasInterview,
                      shooter: this.state.shooter
                    }}
                    getDetails={this.getDetails}
                    shooterList={this.state.shooterList}
                    history={this.props.history}
                    location={this.props.location}
                    match={this.props.match}
                  />
                  {/* SHOOT DETAILS */}
                  <ClientLanguageSection
                    openDialog={this.addLanguage}
                    handleToggle={this.handleToggle}
                    data={this.state.languages}
                    handleToggle={this.handleToggle}
                    disabled={this.state.updatingLanguages}
                    deleteLanguage={this.deletelanguage}
                  />
                  <ClientStaffSection
                    openDialog={this.addStaff}
                    data={this.state.staffs}
                    removeItem={this.removeItem}
                    disabled={this.state.updatingStaffs}
                    edit
                    deleteStaff={this.deleteStaff}
                  />

                  

                  <ClientServicesSection
                    openDialog={this.addService}
                    data={this.state.services}
                    removeItem={this.removeItem}
                    disabled={this.state.updatingServices}
                    edit
                    deleteService={this.deleteService}
                  />
                </Grid>
              </div>
              {/* SHOOT DETAILS */}
            </>
          )}

          <AddStaffDialog
            open={this.state.addStaffDialog}
            handleClose={this.addStaff}
            addStaffToState={this.updateState}
            removeItem={this.removeItem}
          />

          <AddServiceDialog
            open={this.state.addServiceDialog}
            handleClose={this.addService}
            addServiceToState={this.updateState}
            removeItem={this.removeItem}
          />

          <AddLanguageDialog
            open={this.state.addLanguageDialog}
            handleClose={this.addLanguage}
            addLanguageToState={this.updateState}
            removeItem={this.removeItem}
          />
        </ContentWrapper>
        <ConfirmationDialog />
      </AdminWrapper>
    );
  }
};

const mapStateToProps = state => {
  return {
    confirmDialog: state.dialog.confirm.open,
    confirmAction: state.dialog.confirm.action,
    confirmChoice: state.dialog.confirm.confirmed
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dialogActions: bindActionCreators(dialogActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditShoot);
